import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError, EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AlertService, AlertType } from '@solcre-org/core-ui';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ConflictInterceptor implements HttpInterceptor {
    private alertService = inject(AlertService);
    private translateService = inject(TranslateService);

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 409) {
                    const isRateMutation = request.url.includes('/clients/') && request.url.includes('/rates') && request.method !== 'GET';
                    const message = error.error?.detail
                      || error.error?.title
                      || (isRateMutation
                        ? this.translateService.instant('rates.errors.historicalRateConflict')
                        : this.translateService.instant('errors.generic'));

                    this.alertService.show({
                        type: AlertType.ERROR,
                        message: message,
                        duration: 8000,
                        inBottom: true,
                    });

                    return EMPTY; // prevents other alerts
                }

                return throwError(() => error);
            })
        );
    }
}
